import { render, staticRenderFns } from "./PxMatrizPreco.vue?vue&type=template&id=3b50aa2c&scoped=true&"
import script from "./PxMatrizPreco.vue?vue&type=script&lang=js&"
export * from "./PxMatrizPreco.vue?vue&type=script&lang=js&"
import style0 from "./PxMatrizPreco.vue?vue&type=style&index=0&id=3b50aa2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50aa2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
